<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">
  <div
    *idtLet="timeToCountdown$ | async as timeToCountdown"
    class="container">
    <div
      *ngIf="timeToCountdown"
      class="container-time">
      <div
        *ngIf="dateStyle?.showDaysToggle"
        class="col-time days">
        <render-wysiwyg
          [html]="dateStyle!.daysTextFormat | interpolateDateField: timeToCountdown.days: 'Day'"
          [country]="country"
          [lang]="lang"
          [piece]="piece">
        </render-wysiwyg>
        <div
          *ngIf="labelStyle?.showLabelToggle && labelStyle!.showDaysToggle"
          class="labels">
          <render-wysiwyg
            [textPaddingTop]="labelStyle!.labelDayPaddingTop"
            [textPaddingBottom]="labelStyle!.labelDayPaddingBottom"
            [textPaddingLeft]="labelStyle!.labelDayPaddingLeft"
            [textPaddingRight]="labelStyle!.labelDayPaddingRight"
            [html]="labelStyle!.daysTextFormat"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </div>
      </div>

      <div
        *ngIf="dateStyle?.showHoursToggle"
        class="col-time">
        <render-wysiwyg
          [html]="dateStyle!.hoursTextFormat | interpolateDateField: timeToCountdown.hours: 'Hour'"
          [country]="country"
          [lang]="lang"
          [piece]="piece">
        </render-wysiwyg>
        <div
          *ngIf="labelStyle?.showLabelToggle && labelStyle!.showHoursToggle"
          class="labels">
          <render-wysiwyg
            [textPaddingTop]="labelStyle!.labelHourPaddingTop"
            [textPaddingBottom]="labelStyle!.labelHourPaddingBottom"
            [textPaddingLeft]="labelStyle!.labelHourPaddingLeft"
            [textPaddingRight]="labelStyle!.labelHourPaddingRight"
            [html]="labelStyle!.hoursTextFormat"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </div>
      </div>

      <div
        *ngIf="dateStyle?.showMinutesToggle"
        class="col-time">
        <render-wysiwyg
          [html]="dateStyle!.minutesTextFormat | interpolateDateField: timeToCountdown.minutes: 'Minute'"
          [country]="country"
          [lang]="lang"
          [piece]="piece">
        </render-wysiwyg>
        <div
          *ngIf="labelStyle?.showLabelToggle && labelStyle!.showMinutesToggle"
          class="labels">
          <render-wysiwyg
            [textPaddingTop]="labelStyle!.labelMinutePaddingTop"
            [textPaddingBottom]="labelStyle!.labelMinutePaddingBottom"
            [textPaddingLeft]="labelStyle!.labelMinutePaddingLeft"
            [textPaddingRight]="labelStyle!.labelMinutePaddingRight"
            [html]="labelStyle!.minutesTextFormat"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </div>
      </div>

      <div
        *ngIf="dateStyle?.showSecondsToggle"
        class="col-time">
        <render-wysiwyg
          [html]="dateStyle!.secondsTextFormat | interpolateDateField: timeToCountdown.seconds: 'Second'"
          [country]="country"
          [lang]="lang"
          [piece]="piece">
        </render-wysiwyg>
        <div
          *ngIf="labelStyle?.showLabelToggle && labelStyle!.showSecondsToggle"
          class="labels">
          <render-wysiwyg
            [textPaddingTop]="labelStyle!.labelSecondPaddingTop"
            [textPaddingBottom]="labelStyle!.labelSecondPaddingBottom"
            [textPaddingLeft]="labelStyle!.labelSecondPaddingLeft"
            [textPaddingRight]="labelStyle!.labelSecondPaddingRight"
            [html]="labelStyle!.secondsTextFormat"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </div>
      </div>
    </div>

    <progress-bar
      *ngIf="settings?.general?.progressBar?.showProgressBarToggle && timeToCountdown"
      [backgroundColor]="settings!.general!.progressBar!.backgroundColor"
      [foregroundColor]="settings!.general!.progressBar!.foregroundColor"
      [size]="settings!.general!.progressBar!.width"
      [currentProgress]="timeToCountdown.percent">
    </progress-bar>

    <div
      *ngIf="settings?.general?.finalCounterText?.showTextToggle && timeToCountdown === undefined"
      class="col-is-time">
      <render-wysiwyg
        [textPaddingTop]="settings!.general!.finalCounterText.finalCounterTextPaddingTop"
        [textPaddingBottom]="settings!.general!.finalCounterText.finalCounterTextPaddingBottom"
        [textPaddingLeft]="settings!.general!.finalCounterText.finalCounterTextPaddingLeft"
        [textPaddingRight]="settings!.general!.finalCounterText.finalCounterTextPaddingRight"
        [html]="settings!.general!.finalCounterText.text"
        [country]="country"
        [lang]="lang"
        [piece]="piece">
      </render-wysiwyg>
    </div>
  </div>
</idt-common-styles-render>
